
import {
  SAVE_CARE_PLAN,
  SAVE_CLIENTS_SIGN,
  SAVE_CLIENT_CLINIC,
  SAVE_CLIENT_PENDING_QUESTIONNAIRES,
  SAVE_CLIENT_QUESTIONNAIRES,
  SAVE_CP_RESIGN_NOTIFICATION,
  SAVE_GENERICSUCCESS,
} from '../actions/types';

const initialState = {
  clientSigns: [],
  clientClinicInfo: {},
  carePlanResponseList: [],
  genericSuccessResp: false,
  pendingQuestionnaires: [],
  completedQuestionnaires: [],
  carePlanReSignNotificationList: []
};

export const ClientReducer = (state = initialState, action: any) => {
  const oldState = { ...state };
  const { type, payload } = action;
  switch (action.type) {
    case SAVE_CLIENTS_SIGN:
      return {
        ...state,
        clientSigns: payload,
      };

    case SAVE_CLIENT_CLINIC:
      return {
        ...state,
        clientClinicInfo: payload,
      };

    case SAVE_GENERICSUCCESS:
      return {
        ...oldState,
        genericSuccessResp: payload,
      };

    case SAVE_CARE_PLAN:
      return {
        ...oldState,
        carePlanResponseList: payload,
      };

    case SAVE_CLIENT_QUESTIONNAIRES:
      return {
        ...oldState,
        completedQuestionnaires: payload,
      };

    case SAVE_CLIENT_PENDING_QUESTIONNAIRES:
      return {
        ...oldState,
        pendingQuestionnaires: payload,
      };

    case SAVE_CP_RESIGN_NOTIFICATION:
      return {
        ...state,
        carePlanReSignNotificationList: payload,
      }

    default:
      return { ...state };
  }
};
